import React from 'react';
import { useMeterPoleLinks } from '../../../../features/meter/hooks/useMeter';

export interface PoleLinkMiniPresenterProps {
  deviceId?: string;
}

// Cellule "Poteau" de la liste des compteurs: affiche le poteau auquel le compteur
// est REELLEMENT relie (lien pl_link d'un Plan BT), ou "—" si aucun lien.
export default function PoleLinkMiniPresenter({
  deviceId,
}: PoleLinkMiniPresenterProps) {
  const { data, isLoading } = useMeterPoleLinks();

  if (isLoading) return <>...</>;
  if (!deviceId) return <>—</>;

  const entry = data?.find((x) => x.meterNumber === deviceId);
  if (!entry) return <>—</>;

  return <>{entry.poleName || entry.poleNumber || '—'}</>;
}
